// import { isPageDocument, isPageLayoutDocument } from "../util/document";
import upgrade1 from "./v1/upgrade1";
import upgrade2 from "./v1/upgrade2";
export function upgrade(document) {
  if (!document.version || document.version < "1.1") {
    document = upgrade1(document);
  }
  if (document.version < "1.2") {
    document = upgrade2(document);
  }
  return document;
}